import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { CATERING_PACKAGE_FORM } from '../../app-main/components/reduxForms/constants/formNames';
import ModalManager from '../../elements-modal/modal-manager';
import { createOrderPayload, fetchRedirectUrl } from '../catering-utils';
import { CateringAddOnsModal } from './catering-add-ons/CateringAddOnsModal';
import { CateringLoadingModal } from './CateringLoadingModal';
import { CateringOrderSummaryModal } from './CateringOrderSummaryModal';
import { CateringPackageFormModal } from './CateringPackageFormModal';

class CateringPackageOrderFlowCmp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentModal: 'cateringFormModal',
      errorMsg: ''
    };

    this.handleContinueToPayment = this.handleContinueToPayment.bind(this);
  }

  async handleContinueToPayment() {
    // need to open new window before async call to avoid popup blockers
    const newWindow = window.open('', '_blank');

    this.setState({ currentModal: 'cateringLoadingModal' });
    const { formValues, cateringPackage, booking, profile, accessToken } =
      this.props;

    const orderPayload = createOrderPayload(
      formValues,
      cateringPackage,
      booking,
      profile?.data
    );

    try {
      const redirectUrlRes = await fetchRedirectUrl(
        accessToken,
        booking._id,
        orderPayload
      );
      if (redirectUrlRes.error) {
        throw redirectUrlRes.error;
      }
      if (redirectUrlRes.success) {
        newWindow.location.href = redirectUrlRes.redirect_url;
      }

      window.location.href = `/inbox/${booking._id}`;
    } catch (error) {
      newWindow.close();
      this.setState({
        currentModal: 'cateringOrderSummaryModal',
        errorMsg:
          'Something went wrong. Please try again or contact us at catering@peerspace.com'
      });
    }
  }

  render() {
    const { cateringPackage, closeModal, booking, profile } = this.props;

    return (
      <ModalManager whichModal={this.state.currentModal}>
        <CateringPackageFormModal
          ref="cateringFormModal"
          cateringPackage={cateringPackage}
          closeModal={closeModal}
          onNext={() =>
            this.setState({
              currentModal: 'cateringAddOnsModal'
            })
          }
        />

        <CateringAddOnsModal
          ref="cateringAddOnsModal"
          cateringPackage={cateringPackage}
          booking={booking}
          profile={profile}
          closeModal={closeModal}
          onBack={() => this.setState({ currentModal: 'cateringFormModal' })}
          onNext={() =>
            this.setState({
              currentModal: 'cateringOrderSummaryModal'
            })
          }
        />

        <CateringOrderSummaryModal
          ref="cateringOrderSummaryModal"
          closeModal={closeModal}
          cateringPackage={cateringPackage}
          booking={booking}
          profile={profile}
          errorMsg={this.state.errorMsg}
          onBack={() => this.setState({ currentModal: 'cateringAddOnsModal' })}
          onNext={() => {
            this.handleContinueToPayment();
          }}
        />

        <CateringLoadingModal
          ref="cateringLoadingModal"
          closeModal={closeModal}
        />
      </ModalManager>
    );
  }
}

const mapStateToProps = ({ form, profile, auth }) => ({
  formValues: form[CATERING_PACKAGE_FORM]?.values,
  profile,
  accessToken: auth?.accessToken
});

export const CateringPackageOrderFlow = connect(mapStateToProps)(
  reduxForm({
    form: CATERING_PACKAGE_FORM,
    onSubmit: () => {}
  })(CateringPackageOrderFlowCmp)
);
